import { createSvgComponent } from "../../icon/createSvgComponent";
import Chevronup from "@core/__generated__/icon/figma/chevronup.svg";
export default createSvgComponent(Chevronup);